module.exports = __webpack_public_path__ + "static/media/botones-17.f27b6bdb.png";